/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * OBJECTS
 */
const Index = ({
  paymentId,
  onPaymentUpdate,
  onPaymentDelete,
  PassOnUpdate
}) => (
  <Menu placement='left'>
    <MenuButton
      as={Button}
      margin='auto'
      borderRadius='8px'
      color='gray.500'
      bg='transparent'>
      <HiPencil size={18} />
    </MenuButton>
    <MenuList
      className='dropDownMenu'
      maxHeight='400px'
      overflow='auto'>
      <MenuItem
        gap='12px'
        display='flex'
        pl='20px'
        pr='20px'
        color='gray.500'
        onClick={() => {
          // Push vendorAccount id to url.
          PassOnUpdate({ paymentId })

          // Execute handler.
          onPaymentUpdate()
        }}
        minH='40px'>
        <HiPencil size={18} />
        <span>Update Payment</span>
      </MenuItem>
      <MenuItem
        gap='12px'
        display='flex'
        pl='20px'
        pr='20px'
        color='gray.500'
        onClick={() => {
          // Push vendorAccount id to url.
          PassOnUpdate({ paymentId })

          // Execute handler.
          onPaymentDelete()
        }}
        minH='40px'>
        <HiTrash />
        <span>Delete Payment</span>
      </MenuItem>
    </MenuList>
  </Menu>
)


/*
 * PROPTYPES
 */
Index.propTypes = {
  'onPaymentUpdate': PropTypes.func,
  'onPaymentDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'paymentId': PropTypes.string
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
